import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_USER_BY_ID_QUERY_KEY } from './useGetUserById';

import UserService, { UpdateUserDto } from '@/services/UserService';

export function useUpdateUser(id: number, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: UpdateUserDto) => UserService.updateUser(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GET_USER_BY_ID_QUERY_KEY(id) });
      queryClient.invalidateQueries({ queryKey: ['users-info'] });
      if (onSuccess) onSuccess();
    },
  });

  return {
    updateUser: mutateAsync,
    isLoading: isPending,
  };
}
